import React from 'react';

class Footer extends React.Component {
	render() {
		const translate = this.props.translate
		return (
			// <footer className="cpoy-right-bg">
			<div
				className="container footerDiv"
				style={{
					background:
						!this.props.imagesList || this.props.imagesList.length === 0 ? 'transparent' : '#f4f4f4',
				}}
			>
				<div className="row" style={{ marginBottom: 15, marginTop: 10 }}>

					<p className={`poweredSlideText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`This site is Powered by Optimize App`]}
					</p>
					{/* <Image className="headLogo" src={"assets/images/LogoPurple.svg"} /> */}

					<a
						href="https://app.adjust.com/fw3cwi8?label=OptimizeShop&redirect=https%3A%2F%2Fwww.optimizeapp.com%2Fdownload"
						target="_blank"
						rel="noopener noreferrer"
						className={`getYoursText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`Get yours now!`]}
					</a>
					{/* <div className="col-md-12 text-center">
								<div className="social-footer">
									<ul>
										<li>
											<a
												href={null}
												dangerouslySetInnerHTML={{
													__html: '<i class="fa fa-facebook" aria-hidden="true"></i>',
												}}
											/>
										</li>
										<li>
											<a
												href={null}
												dangerouslySetInnerHTML={{
													__html: '<i class="fa fa-google-plus" aria-hidden="true"></i>',
												}}
											/>
										</li>
										<li>
											<a
												href={null}
												dangerouslySetInnerHTML={{
													__html: '<i class="fa fa-twitter" aria-hidden="true"></i>',
												}}
											/>
										</li>
										<li>
											<a
												href={null}
												dangerouslySetInnerHTML={{
													__html: '<i class="fa fa-instagram" aria-hidden="true"></i>',
												}}
											/>
										</li>
										<li>
											<a
												href={null}
												dangerouslySetInnerHTML={{
													__html: '<i class="fa fa-rss" aria-hidden="true"></i>',
												}}
											/>
										</li>
									</ul>
								</div>
							</div>
							 */}
					{/* <div className="col-md-12 text-center"> */}
					{/* <p
						className="copyright"
						style={{
							color: ((this.props.explore_products && this.props.explore_products.length > 0)
								|| (this.props.imagesList && this.props.imagesList.length > 0))
								? '#75647C' : '#FFFFF',
						}}
					>
						{translate['Powered by']}
					</p>
					<a
						href="https://app.adjust.com/7a6vrs6?label=Optimize Shop Footer&redirect=https%3A%2F%2Fwww.optimizeapp.com%2Fdownload"
						// id="copyrightOptimizeApp"
						target="_blank"
						rel="noopener noreferrer"
					>
						<h5
							id="copyrightOptimizeApp"
							style={{
								color: ((this.props.explore_products && this.props.explore_products.length > 0)
									|| (this.props.imagesList && this.props.imagesList.length > 0))
									? '#75647C' : '#FFFFF',
							}}
						>
							OptimizeApp
						</h5>
					</a> */}

					{/* </div> */}
				</div>


			</div>
			// </footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js